// ============================================================
// OTRAROOM TRASTEROS — Configuración editable del sitio
// Cambia aquí teléfonos, dirección, horarios, FAQ y textos legales.
// ============================================================

const WA_NUMBER = "34693988600";

export const SITE = {
  brandName: "OtraRoom",
  brandSuffix: "Trasteros",
  phoneDisplay: "693 98 86 00",
  phoneHref: "tel:+34693988600",
  whatsappUrl: `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
    "Hola, me interesa alquilar un trastero en Guadalajara. ¿Me podéis dar información?"
  )}`,
  emailDisplay: "admin@otraroom.es",
  emailHref: "mailto:admin@otraroom.es",
  // EDITABLE: fecha de apertura (contador)
  openingDate: "2027-01-01T09:00:00+01:00",
  openingLabel: "1 de enero",
  // EDITABLE: dirección, horario e Instagram
  address: "Calle Perú, 2",
  city: "Guadalajara, España",
  hours: "Acceso 24 horas, 365 días al año",
  instagramUrl: "", // PENDIENTE: pega aquí la URL real de Instagram
  mapsEmbed:
    "https://www.google.com/maps?q=Calle%20Per%C3%BA%202%2C%20Guadalajara%2C%20Espa%C3%B1a&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Calle%20Per%C3%BA%202%2C%20Guadalajara%2C%20Espa%C3%B1a",
};

const U = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: U("photo-1770720086655-22f3d1205dc2", 2000), // pasillo puertas amarillas
  yellowDoors: U("photo-1694601618351-dbbbb2b8934f"),
  carAccess: U("photo-1696976004001-e714f32f2fa5", 1800), // coche en instalaciones
  cctv: U("photo-1549109926-58f039549485"),
  loadingZone: U("photo-1759277700771-137173db0e5b"),
  interiorHall: U("photo-1786306781460-3d2171115b5d"),
  interiorRoom: U("photo-1696976004140-3d547f62667b"),
  boxesSmall: U("photo-1624137527136-66e631bdaa0e", 900),
  boxesRoom: U("photo-1663625318264-695d2d04f11a", 900),
  boxesOpen: U("photo-1700165644892-3dd6b67b25bc", 900),
  boxesBig: U("photo-1696976004140-3d547f62667b", 900),
  // EDITABLE: imágenes de "qué cabe en cada tamaño" (curadas por diseño)
  sizeS: "https://images.unsplash.com/photo-1563820510191-3b4a20c78568?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxzdGFja2VkJTIwY2FyZGJvYXJkJTIwYm94ZXN8ZW58MHx8fDE3OTE4MzkyMzN8MA&ixlib=rb-4.1.0&q=85",
  sizeM: "https://images.unsplash.com/photo-1752606302437-bde1f84687b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6NzV8MHwxfHNlYXJjaHwxfHxiaWN5Y2xlJTIwcmFjayUyMGluZG9vciUyMHN0b3JhZ2V8ZW58MHx8fDE3OTE4MzkyNDF8MA&ixlib=rb-4.1.0&q=85",
  sizeLplus: "https://images.unsplash.com/photo-1585541867306-d564450f6fe6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzb2ZhJTIwZnVybml0dXJlJTIwbW92aW5nJTIwYm94ZXN8ZW58MHx8fDE3OTE4MzkyMzN8MA&ixlib=rb-4.1.0&q=85",
  sizeXl: "https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxmdWxsJTIwaG9tZSUyMG1vdmUlMjBwYWNrZWQlMjBzdG9yYWdlJTIwYm94ZXN8ZW58MHx8fDE3OTE4MzkyMzN8MA&ixlib=rb-4.1.0&q=85",
  sizeXxl: "https://images.unsplash.com/photo-1657049199023-87fb439d47c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxtb3ZpbmclMjBsYXJnZSUyMGZ1cm5pdHVyZSUyMHNvZmElMjB3YXJkcm9iZXxlbnwwfHx8fDE3OTE5OTIyNzV8MA&ixlib=rb-4.1.0&q=85",
  fachada: "/assets/fachada.png",
  plano: "/assets/plano-c2.png",
};

export const SIZES = [
  {
    id: "s",
    num: "01",
    label: "S · 1–2 m²",
    desc: "Ideal para cajas, maletas, ropa y material deportivo.",
    price: 35,
    img: IMAGES.sizeS,
    testid: "size-card-consult-button-s",
  },
  {
    id: "m",
    num: "02",
    label: "M · 2–3 m²",
    desc: "Ideal para bicis, equipaje de temporada y cajas.",
    price: 45,
    img: IMAGES.sizeM,
    testid: "size-card-consult-button-m",
  },
  {
    id: "l",
    num: "03",
    label: "L · 3–4 m²",
    desc: "Ideal para muebles, mudanzas y almacenamiento familiar.",
    price: 65,
    img: IMAGES.sizeLplus,
    testid: "size-card-consult-button-l",
  },
  {
    id: "xl",
    num: "04",
    label: "XL · 4–5 m²",
    desc: "Ideal para mudanzas completas o material de autónomos.",
    price: 75,
    img: IMAGES.sizeXl,
    testid: "size-card-consult-button-xl",
  },
  {
    id: "xxl",
    num: "05",
    label: "XXL · +5 m²",
    desc: "Ideal para empresas, stock o grandes necesidades de almacenamiento.",
    price: 95,
    img: IMAGES.sizeXxl,
    testid: "size-card-consult-button-xxl",
  },
];

// EDITABLE: respuestas de las preguntas frecuentes
export const FAQS = [
  {
    q: "¿Cuándo abre OtraRoom?",
    a: "La apertura está prevista para enero de 2027 en Calle Perú, 2 (Guadalajara). Ya puedes ver los precios de apertura en la sección de tamaños, y si haces tu prerreserva tendrás descuento en tu primer mes y prioridad para elegir tamaño antes que nadie.",
  },
  {
    q: "¿Cuáles son los horarios de acceso?",
    a: "Tienes acceso 24 horas al día, 365 días al año. Entra a tu trastero cuando lo necesites, de día, de noche o en festivos: tu espacio siempre disponible.",
  },
  {
    q: "¿Dónde está OtraRoom?",
    a: "En Calle Perú, 2, en Guadalajara capital. Una ubicación cómoda y cercana para que tu trastero te pille al lado de casa o de tu negocio.",
  },
  {
    q: "¿Hay permanencia?",
    a: "Trabajamos con contratos flexibles pensados para particulares y empresas. Cuéntanos cuánto tiempo lo necesitas y te proponemos la opción que mejor encaje contigo.",
  },
  {
    q: "¿Qué puedo guardar?",
    a: "Casi todo lo que te ocupe espacio: muebles, cajas, ropa de temporada, bicis, herramientas, archivo o stock de tu negocio. No se permiten productos ilegales, inflamables o perecederos.",
  },
  {
    q: "¿Cómo se realiza el pago?",
    a: "De forma cómoda y periódica, con los métodos habituales. Antes de firmar te explicamos todas las opciones con total transparencia, sin sorpresas.",
  },
  {
    q: "¿Qué medidas de seguridad tiene OtraRoom?",
    a: "Instalaciones modernas con videovigilancia y acceso controlado, para que tus cosas estén tan bien guardadas como en casa. O mejor.",
  },
  {
    q: "¿Hay seguro?",
    a: "Puedes contar con cobertura para lo que guardas. Consúltanos las opciones de seguro disponibles y te asesoramos sin compromiso.",
  },
  {
    q: "¿Qué documentación necesito?",
    a: "Solo tu DNI o NIE y tus datos de contacto. Si contratas como empresa, los datos fiscales de la misma.",
  },
  {
    q: "¿Cómo hago mi prerreserva?",
    a: "Muy fácil: rellena el formulario de esta página, escríbenos por WhatsApp o llámanos. Te contactaremos para confirmarte la unidad disponible y tu precio de apertura. Sin pago y sin compromiso hasta confirmar apertura y unidad.",
  },
];

// EDITABLE: textos legales (pendientes de redacción definitiva)
export const LEGAL = {
  "aviso-legal": {
    title: "Aviso legal",
    paragraphs: [
      "Este sitio web es titularidad de OtraRoom Trasteros, con domicilio en Calle Perú, 2, Guadalajara (España).",
      "Texto legal completo pendiente de redacción definitiva. Si necesitas más información, contáctanos en el 693 98 86 00 o en admin@otraroom.es.",
    ],
  },
  "politica-de-privacidad": {
    title: "Política de privacidad",
    paragraphs: [
      "Los datos facilitados a través del formulario de contacto se utilizan únicamente para atender tu solicitud de información sobre el alquiler de trasteros.",
      "No cedemos tus datos a terceros. Puedes ejercer tus derechos de acceso, rectificación, supresión y portabilidad contactando con nosotros en el 693 98 86 00 o en admin@otraroom.es.",
      "Texto completo pendiente de redacción definitiva.",
    ],
  },
  "politica-de-cookies": {
    title: "Política de cookies",
    paragraphs: [
      "Este sitio puede utilizar cookies técnicas y de medición anónima para mejorar la experiencia de navegación y medir conversiones.",
      "Texto completo pendiente de redacción definitiva.",
    ],
  },
};
